// extracted by mini-css-extract-plugin
export default {"cell":"cell_cell__GUCVE","cellSelected":"cell_cellSelected__G7Wcv"};